import React from 'react';

// The original "stimulus line" mark — horizontal line with square endpoints
export const LogoMark = ({ width = 36, color = '#8B2635' }) => (
  <svg width={width} height={Math.round(width * 0.38)} viewBox="0 0 36 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="0.75" y="4.75" width="4.5" height="4.5" stroke={color} strokeWidth="1.5" fill="none" rx="0.5"/>
    <line x1="5.25" y1="7" x2="30.75" y2="7" stroke={color} strokeWidth="1.5"/>
    <rect x="30.75" y="4.75" width="4.5" height="4.5" stroke={color} strokeWidth="1.5" fill="none" rx="0.5"/>
  </svg>
);

// Full stacked wordmark lockup matching the original style
export const LogoLockup = ({ size = 28 }) => {
  const stimuliSize  = Math.round(size * 0.57);
  const centralSize  = Math.round(size * 0.4);
  const lineWidth    = Math.round(size * 1.35);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1, userSelect: 'none' }}>
      <span style={{ fontSize: stimuliSize, fontWeight: 700, color: '#8B2635', letterSpacing: '-0.2px', lineHeight: 1.1 }}>
        Stimuli
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <LogoMark width={lineWidth} color="#8B2635" />
        <span style={{ fontSize: centralSize, fontWeight: 500, color: '#6B7280', letterSpacing: '0.2px' }}>
          Central
        </span>
      </div>
    </div>
  );
};
